module.exports = __webpack_public_path__ + "static/foret-verte-59255ec6cb8ebb86ab43107d9254f4ae.jpg";